<template>
  <a-result :style="{ maxWidth: '550px', margin: 'auto' }">
    <template #title>Uwaga!</template>
    <template #subTitle>
      Wkrótce zadamy Ci kilka pytań o Twoje dane osobowe. Przygotuj, proszę,
      swój numer PESEL bądź numer paszportu. Pamiętaj, że podawanie
      nieprawdziwych danych może uniemożliwić Ci uzyskanie dostępu do Internetu
      w przyszłości.
      <br/><br/>
      Pomożemy Ci przejść cały proces rejestracji. W miejscach oznaczonych
      pytajnikiem możesz uzyskać dodatkowe informacje.
    </template>
    <template #icon>
      <a-icon theme="twoTone" type="alert"/>
    </template>
    <template #extra>
      <a-button
          :disabled="!canGoNextStep"
          icon="check"
          size="default"
          type="primary"
          @click="submit"
      >
        Rozumiem, rozpocznij rejestrację...
        <a-badge
            v-if="!canGoNextStep"
            :count="secondsLeft"
            :number-style="{
            backgroundColor: '#fff',
            color: '#999',
            marginLeft: '14px',
            boxShadow: '0 0 0 1px #d9d9d9 inset',
          }"
            showZero
        />
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  data() {
    return {
      secondsLeft: 5,
      canGoNextStep: false,
    };
  },
  mounted() {
    var buttonCountdown = setInterval(() => {
      if (this.secondsLeft > 1) {
        this.secondsLeft -= 1;
      } else {
        this.canGoNextStep = true;
        clearInterval(buttonCountdown);
      }
    }, 1050);
  },
  methods: {
    submit: function () {
      this.$emit("nextStep");
    },
  },
  computed: {
    isVerificationCompleted: function () {
      return (
          this.connection === "ok" &&
          this.router === "ok" &&
          this.details === "ok" &&
          this.verification === "ok"
      );
    },
  },
};
</script>